





















































import { defineComponent, watch } from '@vue/composition-api';
import { useHosting } from './hosting.hook';
import APrimaryBtn from '../base/app/buttons/APrimaryBtn.vue';

export default defineComponent({
  name: 'HostingSearch',
  components: { APrimaryBtn },
  setup() {
    const {
      t,
      isPageInformationReady,
      isLoading,
      searchTerm,
      getHostingByTerm,
      hostingResponse,
      goToOrderLink,
      noResults
    } = useHosting();

    watch(searchTerm, () => {
      getHostingByTerm();
    });

    return {
      t,
      isPageInformationReady,
      searchTerm,
      isLoading,
      getHostingByTerm,
      hostingResponse,
      goToOrderLink,
      noResults
    };
  }
});
